import React from "react";
// Import your images here
import blog1 from "../img/about_1.jpg"; 
import blog2 from "../img/about_2.jpg";
import blog3 from "../img/about_3.jpg";

const CareerTips = () => {
  const blogPosts = [
    {
      id: 1,
      image: blog1,
      date: "24 Feb, 2024",
      author: "John Doe",
      title: "How to write a perfect resume?",
      excerpt: "A well-crafted resume is your ticket to a job interview. Learn the key strategies to make your CV stand out.",
      delay: "0.1s",
      url: "/blog/how-to-write-perfect-resume" // <--- 1. Linked to Resume Page
    },
    {
      id: 2,
      image: blog2,
      date: "26 Feb, 2024",
      author: "Jane Smith",
      title: "Remote Work Trends in 2024",
      excerpt: "The world of work is changing. Discover the latest trends in remote jobs and how to stay productive at home.",
      delay: "0.3s",
      url: "/blog/future-of-remote-work-trends" // <--- 2. Linked to Remote Work Page
    },
    {
      id: 3,
      image: blog3,
      date: "28 Feb, 2024",
      author: "Mike Ross",
      title: "Top Interview Questions & Answers",
      excerpt: "Prepare for your next interview with our list of top common questions and expert advice on how to answer them.",
      delay: "0.5s",
      url: "/blog/top-20-common-interview-questions-answers" // <--- 3. Linked to Interview Page
    }
  ];

  const hoverStyle = {
    transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease",
    cursor: "pointer"
  };

  return (
    <div className="container-fluid py-5 bg-light">
      <div className="container">
        <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
          Career Tips & News
        </h1>
        <div className="row g-4">
          {blogPosts.map((post) => (
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay={post.delay}
              key={post.id}
            >
              <div
                className="bg-white rounded shadow-sm overflow-hidden h-100 card-hover"
                style={hoverStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.boxShadow = "0 .5rem 1rem rgba(0,0,0,.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 .125rem .25rem rgba(0,0,0,.075)";
                }}
              >
                {/* --- LINK 1: WRAP IMAGE IN ANCHOR TAG --- */}
                <div className="position-relative overflow-hidden">
                  <a href={post.url}>
                      <img
                        className="img-fluid w-100"
                        src={post.image}
                        alt={post.title}
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                  </a>
                  <div className="bg-primary rounded text-white position-absolute start-0 top-0 m-4 py-1 px-3">
                    {post.date.split(" ")[0]} {post.date.split(" ")[1]}
                  </div>
                </div>

                {/* Content Section */}
                <div className="p-4">
                  <div className="d-flex mb-3">
                    <small className="me-3">
                      <i className="fa fa-user text-primary me-2"></i>
                      {post.author}
                    </small>
                    <small>
                      <i className="fa fa-folder text-primary me-2"></i>Career Advice
                    </small>
                  </div>

                  {/* --- LINK 2: WRAP TITLE IN ANCHOR TAG --- */}
                  <h5 className="mb-3">
                    <a href={post.url} className="text-dark text-decoration-none">
                        {post.title}
                    </a>
                  </h5>
                  
                  <p>{post.excerpt}</p>
                  
                  {/* --- LINK 3: READ MORE BUTTON --- */}
                  <a
                    href={post.url}
                    className="text-primary fw-bold text-decoration-none text-uppercase"
                  >
                    Read More <i className="bi bi-chevron-right"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CareerTips;